import type {
  SavingsProductAccrualResponse,
  SavingsProductAccrualStatus
} from '@/interfaces/SavingsProductAccrual.interface';

export function filenameFromContentDisposition(
  header: string | undefined,
  fallback: string
): string {
  if (!header) return fallback;
  const utf8 = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8?.[1]) return decodeURIComponent(utf8[1]);
  const quoted = header.match(/filename="([^"]+)"/i);
  if (quoted?.[1]) return quoted[1];
  const plain = header.match(/filename=([^;]+)/i);
  return plain?.[1]?.trim() || fallback;
}

const SAVINGS_PRODUCT_ACCRUAL_STATUSES: readonly SavingsProductAccrualStatus[] =
  ['complete', 'no_data', 'incomplete'];

/**
 * Only the API may declare the report's completeness — a response that does
 * not match the documented envelope is a contract failure, never business
 * state. Repairing it (e.g. defaulting a missing meta to no_data) would tell
 * the operator that no dated transactions exist when the truth is unknown.
 */
export const isSavingsProductAccrualEnvelope = (
  payload: unknown
): payload is SavingsProductAccrualResponse => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }
  const candidate = payload as {
    data?: unknown;
    meta?: { status?: unknown } | null;
  };
  return (
    Array.isArray(candidate.data) &&
    typeof candidate.meta === 'object' &&
    candidate.meta !== null &&
    typeof candidate.meta.status === 'string' &&
    (SAVINGS_PRODUCT_ACCRUAL_STATUSES as readonly string[]).includes(
      candidate.meta.status
    )
  );
};
